const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
    lista: [], 
    listaUsuario: [],
    listaVeiculo: [],
    listaMetaApuracao: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'META_BASE_SUPERVISOR_TRIMESTRE_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'META_BASE_SUPERVISOR_TRIMESTRE_LISTADO':
            return { ...state, lista: action.payload.data };

        case 'META_BASE_SUPERVISOR_TRIMESTRE_USUARIO_SELECT_LISTADO':
			return {
				...state,
				listaUsuario: action.payload.data
            };

        case 'META_BASE_SUPERVISOR_TRIMESTRE_VEICULO_SELECT_LISTADO':
			return {
				...state,
				listaVeiculo: action.payload.data
            };
        
        case 'META_BASE_SUPERVISOR_TRIMESTRE_APURACAO_LISTADO':
			return {
				...state,
				listaMetaApuracao: action.payload.data
            };
                      
        default:
            return state;
    }
}
